export default __webpack_public_path__ + "static/media/garage5.9bc579ca.jpg";